import type { IcManagementDid } from "@icp-sdk/canisters/ic-management";

export type canister_install_mode = IcManagementDid.canister_install_mode;
export type canister_log_record = IcManagementDid.canister_log_record;
export type canister_status_result = IcManagementDid.canister_status_result;
export type chunk_hash = IcManagementDid.chunk_hash;
export type definite_canister_settings =
  IcManagementDid.definite_canister_settings;
export type environment_variable = IcManagementDid.environment_variable;
export type fetch_canister_logs_result =
  IcManagementDid.fetch_canister_logs_result;
export type list_canister_snapshots_result =
  IcManagementDid.list_canister_snapshots_result;
export type log_visibility = IcManagementDid.log_visibility;
export type read_canister_snapshot_data_response =
  IcManagementDid.read_canister_snapshot_data_response;
export type read_canister_snapshot_metadata_response =
  IcManagementDid.read_canister_snapshot_metadata_response;
export type snapshot = IcManagementDid.snapshot;
export type snapshot_id = IcManagementDid.snapshot_id;
export type take_canister_snapshot_result =
  IcManagementDid.take_canister_snapshot_result;
export type upload_canister_snapshot_metadata_response =
  IcManagementDid.upload_canister_snapshot_metadata_response;

/**
 * @deprecated Use "@icp-sdk/canisters/ic-management" directly instead
 */
export * from "@icp-sdk/canisters/ic-management";

/**
 * Legacy re-export for backward compatibility.
 * @deprecated Use "@icp-sdk/canisters/ic-management" directly instead
 */
export {
  IcManagementCanister as ICManagementCanister,
  type IcManagementCanisterOptions as ICManagementCanisterOptions,
} from "@icp-sdk/canisters/ic-management";
